import { React } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import ReactHtmlParser from "react-html-parser";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericButton from "components/Buttons/GenericButton";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function NewsModal(props) {
  const classes = useStylesGeneric();

  return (
    <Box>
      <Box className={classes.modalHeader}> {props.title} </Box>
      <Box>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Box className={classes.modalSubHeader}>
              {ReactHtmlParser(props.message)}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box textAlign="center">
        <GenericButton 
          typeSubmit={false}
          color="primary"
          onClick={props.onClose} 
          style={{marginTop: "20px"}}
        >
          OK
        </GenericButton>
      </Box>
    </Box>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(NewsModal);
